export const BackArrow = (props: IconProps) => {
  return (
    <svg version="1.1" width={props.width ?? "50px"} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xmlSpace="preserve">
      <g><g><path d="M988.4,731C951,571.4,834.4,349.2,482,302.2V161.5c0-29.3-17.8-55.7-44.9-66.9c-27.1-11.2-58.3-4.9-79,15.8l-320,321.6c-37.4,37.6-37.4,98.3,0,135.9l320.1,321.6c20.7,20.8,51.9,27,79.1,15.8c27.1-11.2,44.9-37.6,44.9-66.9V702.4c120.2,0.1,293.6,16,416.9,92.7c20.5,12.8,46.6,11.9,66.2-2.2C984.7,778.9,993.9,754.4,988.4,731z" /></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></g>
    </svg>
  );
}

export interface IconProps {
  width?: number;
}
